<template>
  <div class="flex flex-col gap-2 w-full items-center">
    <div v-if="isImage(file)">
      <div class="flex flex-col gap-1 items-center">
        <div class="rounded-lg overflow-hidden">
          <img
            :src="fileUrl"
            alt="File preview"
            class="max-w-28 items-center hover:brightness-125 hover:cursor-pointer"
            @click="downloadFile"
          />
        </div>
        <button
          @click="downloadFile"
          class="hover:cursor-pointer hover:underline"
        >
          {{ props.file.name }}
        </button>
      </div>
      <div v-if="file" class="flex flex-row justify-center items-center gap-2">
        <button class="p-2" @click="downloadFile" v-tooltip="'Download File'">
          <i class="pi pi-download text-xl text-primary-700"></i>
        </button>
        <button
          class="p-2"
          @click="() => emits('remove', file)"
          v-tooltip="'Remove File'"
        >
          <i class="pi pi-times text-xl text-red-700"></i>
        </button>
      </div>
    </div>
    <div v-else>
      <div class="flex flex-col gap-1 items-center">
        <i
          class="pi pi-file text-2xl hover:brightness-125 hover:cursor-pointer"
          @click="downloadFile"
        />
        <button
          @click="downloadFile"
          class="hover:cursor-pointer hover:underline"
        >
          {{ props.file.name }}
        </button>
      </div>
      <div v-if="file" class="flex flex-row justify-center items-center gap-2">
        <button class="p-2" @click="downloadFile" v-tooltip="'Download File'">
          <i class="pi pi-download text-xl text-primary-700"></i>
        </button>
        <button
          class="p-2"
          @click="() => emits('remove', file)"
          v-tooltip="'Remove File'"
        >
          <i class="pi pi-times text-xl text-red-700"></i>
        </button>
      </div>
    </div>
  </div>
  <div></div>
</template>

<script setup lang="ts">
const props = defineProps<{
  file: File;
  downloadLabel: string;
}>();

const emits = defineEmits<{
  remove: [event: any];
}>();
const fileUrl = ref("");

watch(
  () => props.file,
  (newFile) => {
    if (newFile) {
      fileUrl.value = URL.createObjectURL(newFile);
    }
  },
  { immediate: true },
);

const isImage = (file: File) => {
  return file && file.type.startsWith("image/");
};

const downloadFile = () => {
  const a = document.createElement("a");
  a.href = fileUrl.value;
  a.download = props.file.name;
  a.click();
};
</script>

<style scoped>
.image-preview {
  max-width: 100%;
  max-height: 100%;
}
</style>
